import { render, staticRenderFns } from "./mobileBox.vue?vue&type=template&id=f8883e20&scoped=true&"
import script from "./mobileBox.vue?vue&type=script&lang=js&"
export * from "./mobileBox.vue?vue&type=script&lang=js&"
import style0 from "./mobileBox.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mobileBox.vue?vue&type=style&index=1&id=f8883e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8883e20",
  null
  
)

export default component.exports